import { ENotAuthNavigation } from '@hts/shared/enums';
import { memo, useCallback, useState } from 'react';
import { IMappedSubmenuCategory } from '../../../shared/types';
import { HtsLink } from '../../../shared/ui';
import styles from '../../styles/Header/SubmenuItem.module.scss';
import { HoverSubmenus } from './HoverSubmenus';

interface ISubmenuItemProps {
  item: IMappedSubmenuCategory;
}

export const SubmenuItem = memo<ISubmenuItemProps>(({ item }) => {
  const { categories, id, fileUrl: mediaPath, name, slug } = item;

  const [isOpenSubmenu, setOpenSubmenu] = useState(false);

  const hasCategories = categories.length > 0;

  const onCloseSubmenu = useCallback(() => {
    setOpenSubmenu(false);
  }, []);

  const onOpenSubmenu = useCallback(() => {
    setOpenSubmenu(true);
  }, []);

  return (
    <li
      className={styles.container}
      onMouseEnter={hasCategories ? onOpenSubmenu : undefined}
      onMouseLeave={hasCategories ? onCloseSubmenu : undefined}
    >
      <HtsLink
        label={name}
        redirectTo={`${ENotAuthNavigation.CATEGORY_OF_CARD}/${slug}`}
        typographyProps={{ variant: 'body2', fontWeight: '500' }}
        linkProps={{
          onClick: onCloseSubmenu,
          className: `${styles.link} ${!categories.length ? styles.activeLink : ''}`,
        }}
      />

      {Boolean(categories.length) && (
        <HoverSubmenus
          isOpen={isOpenSubmenu}
          submenu={item}
          containerClassName={styles.windowSubmenus}
          onCloseSubmenu={onCloseSubmenu}
        />
      )}
    </li>
  );
});
